import { ApiRequest } from "@plinknz/tah-website-elements";
import { membersLogin } from "../../config/router";

export const whataRequest = new ApiRequest({
    baseUrl: process.env.WHATA_URL || "",
    useCache: false,
    useContentType: true,
    loginPath: membersLogin(),
});
